import React, { useRef } from "react";
import { IdleTimerProvider } from "react-idle-timer";

function IdleTimerContainer() {
  const idleTimerRef = useRef(null);

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login"; 
  };

  return (
    <IdleTimerProvider
      ref={idleTimerRef}
      timeout={18000000}
      onIdle={logOut}
    >
  <>
  </>
    </IdleTimerProvider>
  );
}

export default IdleTimerContainer;
